/*
 * Copyright (c) 2022. Nedaware SL
 */

import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {Resource} from "../../api/resource";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {NestedBehavior} from "../../basic-entity-back/property-type/nested-model-type";
import {TipoEnvio} from "./tipo-envio.model";
import {Transportista} from "./transportista.model";
import {ManagerCachingStrategy, PropertyMap} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {PrioridadEnvio} from "./prioridad-envio.model";

@BasicEntity({
    name: 'TransportistaTipoEnvioRel',
    endpoint: 'transportista_tipo_envio_rels',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    modelNameProperty: 'resumen',
    type: 'TransportistaTipoEnvioRel',
    managerCaching: ManagerCachingStrategy.Lazy
})
export class TransportistaTipoEnvioRel extends Resource {

    @BasicProperty({
        name: 'ID',
        isId: true,
        type: PropertyType.Integer()
    })
    private _id;

    public static readonly MAP_PRIORIDAD_ENVIO: PropertyMap = {
        name: 'Prioridad envío',
        type: PropertyType.FutureUri('prioridad-envio.model.ts')
    }
    @BasicProperty(TransportistaTipoEnvioRel.MAP_PRIORIDAD_ENVIO)
    private _prioridadEnvio;

    @BasicProperty({
        name: 'Transportista',
        type: PropertyType.NestedModel(Transportista, null, NestedBehavior.SendIriOnly),
    })
    private _transportista;

    @BasicProperty({
        name: 'Tipo de envío',
        type: PropertyType.NestedModel(TipoEnvio, null, NestedBehavior.SendIriOnly),
    })
    private _tipoEnvio;


    @BasicProperty({
        name: 'Por defecto',
        type: PropertyType.Boolean(),
    })
    private _porDefecto;

    get resumen() {
        return this.tipoEnvio?.nombre;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get transportista() {
        return this._transportista;
    }

    set transportista(value) {
        this._transportista = value;
    }

    get tipoEnvio() {
        return this._tipoEnvio;
    }

    set tipoEnvio(value) {
        this._tipoEnvio = value;
    }

    get porDefecto() {
        return this._porDefecto;
    }

    set porDefecto(value) {
        this._porDefecto = value;
    }

    get prioridadEnvio() {
        return this._prioridadEnvio;
    }

    set prioridadEnvio(value) {
        this._prioridadEnvio = value;
    }
}
